/*
 * @Author: changcheng 364000100@#qq.com
 * @Date: 2025-08-27 18:31:28
 * @LastEditors: changcheng 364000100@#qq.com
 * @LastEditTime: 2025-08-27 18:32:17
 * @FilePath: /mvw_project/mvw-online-pc/src/components/videoPlayer/CCPlayer.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * @Description: PC 端复用的 CC 播放器组件（无水印）
 */
import React, { useEffect, useRef } from "react";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface Window {}
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const window: Window & { createCCH5Player?: any; ccPlayerStatus?: any };

export interface CCConfig {
  vid: string;
  siteid: string;
  canDrag: number;
  watchStartTime: number;
  allowRateChange: number;
  videoWaterMask?: any; // 保持与移动端一致，即使不使用水印
}

interface CCPlayerProps {
  cc: CCConfig;
  height?: string;
}

const CCPlayer: React.FC<CCPlayerProps> = ({ cc, height = "180px" }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    console.log("[PC CCPlayer] useEffect triggered with config:", cc);
    console.log(
      "[PC CCPlayer] createCCH5Player available:",
      !!window.createCCH5Player
    );
    console.log("[PC CCPlayer] containerRef.current:", !!containerRef.current);

    // 等待CC播放器SDK加载完成
    const initPlayer = () => {
      if (window.createCCH5Player && containerRef.current) {
        const config = {
          vid: cc.vid,
          siteid: cc.siteid,
          autoStart: false,
          width: "100%",
          height,
          banDrag: "false",
          mediatype: "1",
          playtype: 1,
          rate: 1,
          rate_allow_change: !!cc.allowRateChange,
          progressbar_enable: cc.canDrag,
          watchStartTime: cc.watchStartTime,
          parentNode: containerRef.current,
          marquee: undefined, // 与移动端保持一致，即使没有水印也传递此参数
          isShowUrlBtn: false,
        };
        console.log("[PC CCPlayer] Creating player with config:", config);

        try {
          window.ccPlayerStatus = window.createCCH5Player(config);
          console.log(
            "[PC CCPlayer] Player created successfully:",
            !!window.ccPlayerStatus
          );
        } catch (error) {
          console.error("[PC CCPlayer] Error creating player:", error);
        }
      } else {
        console.warn(
          "[PC CCPlayer] Cannot create player - missing dependencies"
        );
        // 如果SDK还没加载完成，等待一段时间后重试
        setTimeout(initPlayer, 100);
      }
    };

    // 检查SDK是否已经加载，如果没有则等待
    if (window.createCCH5Player) {
      initPlayer();
    } else {
      // 监听SDK加载完成事件或定时检查
      const checkSDK = setInterval(() => {
        if (window.createCCH5Player) {
          clearInterval(checkSDK);
          initPlayer();
        }
      }, 100);

      // 10秒后停止检查，避免无限等待
      setTimeout(() => {
        clearInterval(checkSDK);
        console.error("[PC CCPlayer] CC SDK loading timeout");
      }, 10000);
    }

    return () => {
      if (window.ccPlayerStatus) {
        try {
          window.ccPlayerStatus.destroy && window.ccPlayerStatus.destroy();
        } catch {}
        window.ccPlayerStatus = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    cc.vid,
    cc.siteid,
    cc.canDrag,
    cc.watchStartTime,
    cc.allowRateChange,
    height,
    cc.videoWaterMask, // 直接使用对象避免序列化复杂度
  ]);

  return (
    <div
      ref={containerRef}
      id="livePlayer"
      className="disableFullsBtns"
      style={{ height }}
    />
  );
};

export default CCPlayer;
